import SiafLiteApiRepository from "../../external/siafLiteApi";

class PerfilsUsuariosService {
  constructor() {
    this.urlBase = "/painel-controle/perfis-usuarios";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }
}

export default PerfilsUsuariosService;
